import React, { useMemo } from "react"
import { get } from "lodash"
// import ReactPlayer from 'react-player'
// import LazyLoad from 'react-lazyload'
// import { RichText } from 'prismic-reactjs'
// import { linkResolver } from '@prismicio/gatsby-source-prismic-graphql'
// import '../../../node_modules/uikit/dist/js/uikit.js'
import { useWindowSizes } from "@hooks/window"
import Image from "./Image"

const EditorialImages = ({ data, index }) => {
  // console.log('[EditorialImages.js] data', data)

  const { isIpadPro, isIpad, isIphonePlus, isDesktop } = useWindowSizes()

  const image_1 = useMemo(() => get(data, "primary.image_1"), [data])

  const image_2 = useMemo(() => get(data, "primary.image_2"), [data])

  // Image size
  // let imgWidth_2 = 1920
  // isIphonePlus  ? imgWidth_2 = 414 :
  // isIpad        ? imgWidth_2 = 768 :
  // isIpadPro     ? imgWidth_2 = 1024 :
  // isDesktop     ? imgWidth_2 = 1440 :
  // imgWidth_2 = 1920

  const image_3 = useMemo(() => get(data, "primary.image_3"), [data])

  const layout = useMemo(() => get(data, "primary.layout"), [data])

  const renderLayout = () => {
    if (layout === "Wide + Overlay + Square") {
      return (
        <>
          {image_1 ? (
            <div className="editorial_images__wide">
              {/* <img src={image_1?.url} alt={image_1?.alt} /> */}
              <Image image={image_1} width={"full"} />
            </div>
          ) : null}

          <div className="row row-justify">
            {image_2 ? (
              <div className="col col7 editorial_images__image_left">
                {/* <img src={image_2?.url} alt={image_2?.alt} /> */}
                <Image image={image_2} width={"full"} relative={0.55} />
              </div>
            ) : null}

            {image_3 ? (
              <div className="col col4 editorial_images__image_right">
                {/* <img src={image_3?.url} alt={image_3?.alt} /> */}
                <Image image={image_3} width={"full"} relative={0.31} />
              </div>
            ) : null}
          </div>
        </>
      )
    } else if (layout === "Alternate layout") {
      return (
        <>
          <div className="row row-justify">
            <div className="col col4 editorial_images__image_2_left">
              {/* <img src={image_1?.url} alt={image_1?.alt} /> */}
              <Image image={image_1} width={"full"} relative={0.31} />
            </div>
            <div className="col col6 editorial_images__image_2_right">
              {image_2 ? (
                // <img src={image_2?.url} alt={image_2?.alt} />
                <Image image={image_2} width={"full"} relative={0.23} />
              ) : null}

              {image_3 ? (
                // <img src={image_3?.url} alt={image_3?.alt} />
                <Image image={image_3} width={"full"} relative={0.46} />
              ) : null}
            </div>
          </div>
        </>
      )
    } else if (layout === "Classic") {
      return (
        <>
          <div className="row row-justify classic">
            <div className="col col8">
              {/* <img src={image_1?.url} alt={image_1?.alt} /> */}
              <Image image={image_1} width={"full"} relative={0.31} />
            </div>
            <div className="col col6">
              {/* <img src={image_1?.url} alt={image_1?.alt} /> */}
              <Image image={image_2} width={"full"} relative={0.31} />
            </div>
            <div className="col col6">
              {/* <img src={image_1?.url} alt={image_1?.alt} /> */}
              <Image image={image_3} width={"full"} relative={0.31} />
            </div>
          </div>
        </>
      )
    }
  }

  return (
    <section key={index} className="editorial_images">
      {renderLayout()}
    </section>
  )
}

export default EditorialImages
